import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { NavLink } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { NAVIGATION, ONLINE_ACADEMY_URL, SUPPORT_US_URL } from '../data/NavigationData';
import UtilityBar from './UtilityBar';
import TrustBadge from './TrustBadge';
import ukrainian from '../images/ukrainian.svg';
import './Navigation.css';

// Mobile / tablet header (below the 992px breakpoint, see Navigation.css).
// Desktop uses Menu.js. Menu items come from data/NavigationData.js.
function SideBar() {
    const [show, setShow] = useState(false);
    const close = () => setShow(false);

    // One link inside the drawer; closes the drawer when clicked
    const drawerLink = (item, className) => (
        <NavLink key={item.label} to={item.to} end={item.to === '/'} onClick={close} className={className}>
            <Trans ns="navigation" i18nKey={item.label} />
        </NavLink>
    );

    return (
        <div className="siteHeader mobileHeader">
            <UtilityBar />
            <header className="mainBar">
                <div className="mainBarInner">
                    <NavLink to="/" className="mainBarLogo">
                        <img src={ukrainian} width="48" height="48" alt="Ukrainian Logo" />
                    </NavLink>
                    <TrustBadge />
                    <button type="button" className="burgerButton" aria-label="Menu" onClick={() => setShow(true)}>
                        ☰
                    </button>
                </div>
            </header>

            <Offcanvas show={show} onHide={close} placement="end">
                <Offcanvas.Header closeButton />
                <Offcanvas.Body>
                    {/* Items with children become accordions, the rest are plain links */}
                    <Accordion flush>
                        {NAVIGATION.map((item, index) =>
                            item.children ? (
                                <Accordion.Item key={item.label} eventKey={String(index)}>
                                    <Accordion.Header>
                                        <Trans ns="navigation" i18nKey={item.label} />
                                    </Accordion.Header>
                                    <Accordion.Body className="drawerChildren">
                                        {item.children.map((child) => drawerLink(child, 'drawerLink'))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ) : (
                                drawerLink(item, 'drawerLink drawerTopLink')
                            )
                        )}
                    </Accordion>

                    <div className="drawerButtons">
                        <a className="navBtn navBtnSupport" href={SUPPORT_US_URL} target="_blank" rel="noreferrer">
                            <Trans ns="navigation" i18nKey="Support Us" />
                        </a>
                        <a className="navBtn navBtnOutlineDark" href={ONLINE_ACADEMY_URL} target="_blank" rel="noreferrer">
                            <Trans ns="navigation" i18nKey="Online Academy" />
                        </a>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
}

export default SideBar;
